import {
  Dimmer,
  Header,
  Icon,
  type IconJVSProps,
  Loader,
  Segment,
  type SemanticCOLORS,
} from '@mairistem/composants';

type RelanceTileProps = {
  icon: IconJVSProps;
  label: string;
  relancesCount: number;
  facturesCount: number;
  loading?: boolean;
  isMail?: boolean;
  showOnlyTile?: boolean;
  text?: string;
  color?: SemanticCOLORS;
  onClick?: () => void;
};

const RelanceTile = ({
  icon,
  label,
  relancesCount,
  facturesCount,
  loading = false,
  isMail = false,
  showOnlyTile = false,
  text,
  color,
  onClick,
}: RelanceTileProps) => (
  <Segment
    color={color || 'blue'}
    style={{
      flex: 1,
      margin: 0,
      padding: '1.5em',
      maxWidth: 425,
      textAlign: 'center',
      ...(onClick && { cursor: 'pointer' }),
    }}
    onClick={onClick}
  >
    <Dimmer active={loading} inverted>
      <Loader inverted />
    </Dimmer>

    {!loading && (
      <>
        <div style={{ margin: '0 0 0.5em 0' }}>
          <Icon iconSet="Lucide" size={30} {...icon} />
        </div>
        <Header as="h4" color={color} style={{ margin: '0 0 0.5em 0' }}>
          <Header.Content>
            {text || (
              <>
                {showOnlyTile ? 'Les relances' : relancesCount}{' '}
                {showOnlyTile
                  ? isMail
                    ? 'seront envoyées'
                    : 'devront être envoyées'
                  : isMail
                    ? relancesCount <= 1
                      ? 'relance sera envoyée'
                      : 'relances seront envoyées'
                    : relancesCount <= 1
                      ? 'relance devra être envoyée'
                      : 'relances devront être envoyées'}{' '}
                {label}
              </>
            )}
          </Header.Content>
        </Header>

        <Header as="h5" disabled style={{ margin: 0 }}>
          <Header.Content>
            {facturesCount <= 1
              ? `${facturesCount} facture concernée`
              : `${facturesCount} factures concernées`}
          </Header.Content>
        </Header>
      </>
    )}
  </Segment>
);

export default RelanceTile;
